import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { View, Text } from '@olxbr/design-system'

const Content = styled(View)`
  display: flex;
  flex-direction: row;
  height: 84px;
  justify-content: space-between;
  border: 1px solid #e5e5e5;
  box-sizing: border-box;
  align-content: center;
  border-radius: 8px;
  padding: 16px;
`

const BoxContent = styled(View)`
  display: flex;
  flex: 1;
  flex-direction: column;
  padding-left: 16px;
  padding-right: 16px;
`

const BoxShortInfo = ({ title, subtitle, icon, extraOptions }) => (
  <Content>
    {icon}
    <BoxContent>
      <Text size="body2" fontWeight={600} color="dark">
        {title}
      </Text>
      <Text size="caption" color="grayscale.darker">
        {subtitle}
      </Text>
    </BoxContent>
    {extraOptions}
  </Content>
)

BoxShortInfo.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  icon: PropTypes.object,
  extraOptions: PropTypes.object,
}

export default BoxShortInfo
